<div id="save-pdf" class="card">
  <div class="">
    <div class="">
      <div class="">
        <img id="logo" class="login-img" src="assets/images/logohori.png" />
        <h5 class="">Pago exitoso</h5>
        <h6 class="card-subtitle mb-2 text-muted">Su pago ha sido procesado exitosamente</h6>
      </div>
    </div>
    <ul class="list-group">
      <li class="list-group-item d-flex justify-content-between align-items-center">
        <span class="font-weight-bold">Monto</span>
        <span>{{comprobante?.valor | currency}}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center">
        <span class="font-weight-bold">Documento</span>
        <span>{{comprobante?.numeroDocumento}}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center">
        <span class="font-weight-bold">No. Préstamo</span>
        <span>{{comprobante?.numeroPrestamo}}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center">
        <span class="font-weight-bold">Saldo del Préstamo</span>
        <span>{{comprobante?.saldoPrestamo | currency}}</span>
      </li>
      <li class="list-group-item d-flex justify-content-between align-items-center">
        <span class="font-weight-bold">Fecha Actual</span>
        <span>{{fecha}}</span>
      </li>
    </ul>
  </div>
</div>
